/**
 * Whether a project of the given type matches the selected type filter.
 * 'proposal' intentionally groups pre-award pursuits with proposals, since
 * pre_award is a spawned proposal precursor rather than a distinct pill.
 */ export function matchesTypeFilter(type, filter) {
    if (filter === 'all') return true;
    if (filter === 'proposal') return type === 'proposal' || type === 'pre_award';
    return type === filter;
}
